import { render, staticRenderFns } from "./ServiceArea.vue?vue&type=template&id=0ec81c6c&scoped=true"
import script from "./ServiceArea.vue?vue&type=script&lang=js"
export * from "./ServiceArea.vue?vue&type=script&lang=js"
import style0 from "./ServiceArea.vue?vue&type=style&index=0&id=0ec81c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec81c6c",
  null
  
)

export default component.exports